import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DrawerFrameComponent } from './drawer-frame.component';
import { DrawerModule } from 'primeng/drawer';
import { SharedModule } from '../../modules/shared/shared.module';

@NgModule({
  declarations: [
    DrawerFrameComponent
  ],
  imports: [
    CommonModule,
    DrawerModule,
    SharedModule,
  ],
  exports: [
    DrawerFrameComponent
  ]
})
export class DrawerFrameModule { }
